import Vue from 'vue'
import Router from 'vue-router'
import localStore from 'util/localStore'

const login = resolve => require(['page/login/login'], resolve)
const forgetPass = resolve => require(['page/login/forgetPass'], resolve)
const modifyPass = resolve => require(['page/login/modifyPass'], resolve)
const setting = resolve => require(['page/login/setting'], resolve)
const reModifyPass = resolve => require(['page/login/reModifyPass'], resolve)
const modifyPhone = resolve => require(['page/login/modifyPhone'], resolve)
const activePhone = resolve => require(['page/login/activePhone'], resolve)
const modifyEmail = resolve => require(['page/login/modifyEmail'], resolve)
const loginActive = resolve => require(['page/login/loginActive'], resolve)

const search = resolve => require(['page/shopping/search'], resolve)
const shopping = resolve => require(['page/shopping/shopping'], resolve)
const shoppingCart = resolve => require(['page/shopping/shoppingCart'], resolve)
const orderConfirm = resolve => require(['page/shopping/orderConfirm'], resolve)
const orderPay = resolve => require(['page/shopping/orderPay'], resolve)
const payResult = resolve => require(['page/shopping/payResult'], resolve)
const mergePay = resolve => require(['page/shopping/mergePay'], resolve)
const packageSetting = resolve => require(['page/shopping/packageSetting'], resolve)

const mine = resolve => require(['page/mine/mine'], resolve)
const recharge = resolve => require(['page/mine/recharge'], resolve)
const rechargeList = resolve => require(['page/mine/rechargeList'], resolve)
const rechargeDetail = resolve => require(['page/mine/rechargeDetail'], resolve)
const discount = resolve => require(['page/mine/discount'], resolve)
const exchange = resolve => require(['page/mine/exchange'], resolve)
const orderDetail = resolve => require(['page/mine/orderDetail'], resolve)
const orderList = resolve => require(['page/mine/orderList'], resolve)
const teamOrderList = resolve => require(['page/mine/teamOrderList'], resolve)
const notice = resolve => require(['page/mine/notice'], resolve)
const noticeView = resolve => require(['page/mine/noticeView'], resolve)
const temporaryOrder = resolve => require(['page/mine/temporaryOrder'], resolve)
const openApply = resolve => require(['page/mine/openApply'], resolve)
const openApplyProgress = resolve => require(['page/mine/openApplyProgress'], resolve)
const completeApply = resolve => require(['page/mine/completeApply'], resolve)
const basicInfo = resolve => require(['page/mine/basicInfo'], resolve)
const basicInfoF = resolve => require(['page/mine/basicInfoF'], resolve)
const boxing = resolve => require(['page/mine/boxing'], resolve)
const shipped = resolve => require(['page/mine/shipped'], resolve)
const unshipped = resolve => require(['page/mine/unshipped'], resolve)
const transferAccount = resolve => require(['page/mine/transferAccount'], resolve)
const transferAccountHistory = resolve => require(['page/mine/transferAccountHistory'], resolve)
const transferAccountList = resolve => require(['page/mine/transferAccountList'], resolve)

const afterSale = resolve => require(['page/afterSale/afterSale'], resolve)
const afterSaleList = resolve => require(['page/afterSale/afterSaleList'], resolve)
const afterSaleEdit = resolve => require(['page/afterSale/afterSaleEdit'], resolve)
const afterSaleDetail = resolve => require(['page/afterSale/afterSaleDetail'], resolve)
const afterSaleBatch = resolve => require(['page/afterSale/afterSaleBatch'], resolve)

const weekReport = resolve => require(['page/weekReport/weekReport'], resolve)
const weekReportList = resolve => require(['page/weekReport/weekReportList'], resolve)
const weekReportDetail = resolve => require(['page/weekReport/weekReportDetail'], resolve)
const weekReportTeamList = resolve => require(['page/weekReport/weekReportTeamList'], resolve)

const stockList = resolve => require(['page/stock/stockList'], resolve)
const addStock = resolve => require(['page/stock/addStock'], resolve)
const editStock = resolve => require(['page/stock/editStock'], resolve)
const stockPreview = resolve => require(['page/stock/stockPreview'], resolve)
const stockView = resolve => require(['page/stock/stockView'], resolve)
const stockViewPrint = resolve => require(['page/stock/stockViewPrint'], resolve)

const sparepartSubsidyList = resolve => require(['page/mine/sparepartSubsidyList'], resolve)

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/shopping'
    },
    {
      path: '/shopping',
      name: 'shopping',
      component: shopping,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/shoppingCart',
      name: 'shoppingCart',
      component: shoppingCart,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/search',
      name: 'search',
      component: search,
      meta: {
        hasHeader: true,
        keepAlive:true
      }
    },
    {
      path: '/orderConfirm',
      name: 'orderConfirm',
      component: orderConfirm,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/orderPay',
      name: 'orderPay',
      component: orderPay,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/payResult',
      name: 'payResult',
      component: payResult,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/mergePay',
      name: 'mergePay',
      component: mergePay,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/packageSetting',
      name: 'packageSetting',
      component: packageSetting,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: recharge,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/rechargeList',
      name: 'rechargeList',
      component: rechargeList,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/rechargeDetail',
      name: 'rechargeDetail',
      component: rechargeDetail,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/discount',
      name: 'discount',
      component: discount,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/exchange',
      name: 'exchange',
      component: exchange,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: orderList,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/teamOrderList',
      name: 'teamOrderList',
      component: teamOrderList,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/openApply',
      name: 'openApply',
      component: openApply,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/openApplyProgress',
      name: 'openApplyProgress',
      component: openApplyProgress,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/completeApply',
      name: 'completeApply',
      component: completeApply,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/basicInfo',
      name: 'basicInfo',
      component: basicInfo,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/boxing',
      name: 'boxing',
      component: boxing,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/shipped',
      name: 'shipped',
      component: shipped,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/unshipped',
      name: 'unshipped',
      component: unshipped,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/basicInfoF',
      name: 'basicInfoF',
      component: basicInfoF,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/transferAccount',
      name: 'transferAccount',
      component: transferAccount,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/transferAccountList',
      name: 'transferAccountList',
      component: transferAccountList,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/transferAccountHistory',
      name: 'transferAccountHistory',
      component: transferAccountHistory,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/temporaryOrder',
      name: 'temporaryOrder',
      component: temporaryOrder,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: orderDetail,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/afterSale',
      name: 'afterSale',
      component: afterSale,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/afterSaleList',
      name: 'afterSaleList',
      component: afterSaleList,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/afterSaleEdit',
      name: 'afterSaleEdit',
      component: afterSaleEdit,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/afterSaleDetail',
      name: 'afterSaleDetail',
      component: afterSaleDetail,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/afterSaleBatch',
      name: 'afterSaleBatch',
      component: afterSaleBatch,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/weekReport',
      name: 'weekReport',
      component: weekReport,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/weekReportList',
      name: 'weekReportList',
      component: weekReportList,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/weekReportDetail',
      name: 'weekReportDetail',
      component: weekReportDetail,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/weekReportTeamList',
      name: 'weekReportTeamList',
      component: weekReportTeamList,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/loginActive',
      name: 'loginActive',
      component: loginActive,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/modifyPass',
      name: 'modifyPass',
      component: modifyPass
    },
    {
      path: '/setting',
      name: 'setting',
      component: setting,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/reModifyPass',
      name: 'reModifyPass',
      component: reModifyPass,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/modifyEmail',
      name: 'modifyEmail',
      component: modifyEmail,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/modifyPhone',
      name: 'modifyPhone',
      component: modifyPhone,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/activePhone',
      name: 'activePhone',
      component: activePhone,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/forgetPass',
      name: 'forgetPass',
      component: forgetPass,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/stockList',
      name: 'stockList',
      component: stockList,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/addStock',
      name: 'addStock',
      component: addStock,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/editStock',
      name: 'editStock',
      component: editStock,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/stockPreview',
      name: 'stockPreview',
      component: stockPreview,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/stockView',
      name: 'stockView',
      component: stockView,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/stockViewPrint',
      name: 'stockViewPrint',
      component: stockViewPrint
    },
    {
      path: '/notice',
      name: 'notice',
      component: notice,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/noticeView',
      name: 'noticeView',
      component: noticeView,
      meta: {
        hasHeader: true
      }
    },
    {
      path: '/sparepartSubsidyList',
      name: 'sparepartSubsidyList',
      component: sparepartSubsidyList,
      meta: {
        hasHeader: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (typeof (to.meta.requiresAuth) === 'undefined' && !localStore.get('TUP_token')) { // 需要登陆没有token跳登录页
    next({
      name: 'login',
      params: {
        redirect: to.path
      }
    })
  } else if (to.name === 'login' && localStore.get('TUP_token')) { // 已登录状态，不允许新开或回退到登录页
    next({
      path: from.path || '/'
    })
  } else if (to.name !== 'modifyPass' && localStore.get('TUP_pInfo') && localStore.get('TUP_pInfo').pNeedModifyPasswd) { // 需要重置密码
    next({
      path: '/modifyPass',
      query: {
        phone: localStore.get('TUP_pInfo').pMobile
      }
    })
  } else if (to.name !== 'loginActive' && to.name !== 'modifyPass' && localStore.get('TUP_pInfo') && localStore.get('TUP_pInfo').pIsEmailActive === 0) { // 需要重置密码
    debugger
    next({
      path: '/loginActive',
      query: {
        pIsMobileActive: localStore.get('TUP_pInfo').pIsMobileActive,
        pMobile: localStore.get('TUP_pInfo').pMobile,
        pIsEmailActive: localStore.get('TUP_pInfo').pIsEmailActive,
        pEmail: localStore.get('TUP_pInfo').pEmail,
        pActiveProvince: localStore.get('TUP_pInfo').pActiveProvince,
        pActiveCity: localStore.get('TUP_pInfo').pActiveCity,
        pActiveArea: localStore.get('TUP_pInfo').pActiveArea
      }
    })
  } else {
    //console.log("---router-->>>",from,to)
    next()
  }
  // else if (typeof (to.meta.requiresAuth) === 'undefined' && window.localStorage.getItem('TUP_token') && window.localStorage.getItem('TUP_pIsEmailActive') === 'false') {
  //   // 需要登陆有token，邮箱未激活跳账号激活页
  //   next({
  //     name: 'loginActive',
  //     params: {
  //       redirect: to.path
  //     }
  //   })
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js